export enum RouteName {
  activityView = "/activity",
  auctionsView = "/auctions",
  home = "/",
  marketplace = "/marketplace",
  marketplaceMint = "/marketplace/:tokenMint",
  sell = "/sell",
  customToken = "/custom-token-marketplace",
  multipleCollection = "/multi-collection-marketplace",
  marketplaceWithUrl = "/marketplace-with-url",
  multipleCurrencyMarketplace = "/multi-currency-marketplace",
  multipleCurrencySell = "/multi-currency-sell",
}
